import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { ClipLoader } from "react-spinners";
import "./report.css"
import { FaCalendarAlt } from "react-icons/fa";
import LineChart from './lineChart';
import { ReactComponent as Chart } from '../../../assets/images/svgIcons/Chart.svg';
import ApiService from '../../../services/apiService';

const Reports = ({}) => {
    let navigate = useNavigate();
    const [selectedFilter, setSelectedFilter] = useState('4');
    const [data, setData] = useState([]);

    useEffect(() => {
    }, []);
    const handleFilterChange = async (selectedFilter) => {
        setSelectedFilter(selectedFilter?.value);
        console.log('Selected Option:', selectedFilter);
        await getSumData();
    };
    const getSumData = async () => {
        try {
            const apiService = new ApiService();
            let paramaters = `?GetBy=${selectedFilter}`;
            
            let res = await apiService.getApiParamater("GET_SALE_REPORTS", paramaters);
            setData(res?.data?.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const ThirdFilter = [
        { value: '0', label: 'Day' },
        { value: '1', label: 'Week' },
        { value: '2', label: 'Month' },
        { value: '3', label: 'Year' },
        { value: '4', label: 'All Time' },
    ];
    const handlechart = () => {
        navigate('/admin/Reports/Grid')
    }
    return (
        <div className='p-lg-5'>
            <div className='px-lg-5'>
                <div className='d-flex justify-content-between' >
                    <div className='viebtn' onClick={() => handlechart()}><Chart /></div>
                    <div className='d-flex mbl-center gap-3'>
                        <div className='d-flex'>
                            <nav className="nav nav-pills weekfilter ">
                                {ThirdFilter.map((filter) => (
                                    <button
                                        key={filter.value}
                                        className={`nav-link ${selectedFilter === filter.value ? 'activecls' : ''}`}
                                        onClick={() => handleFilterChange(filter)}
                                    >
                                        {filter.label}
                                    </button>
                                ))}
                            </nav>
                        </div>
                        <div className='custom center gap-2'>Custom <FaCalendarAlt /></div>
                    </div>
                </div>
                <div className='mt-5 earn'>
                    <div className='p-4 earntxt'>Earning</div>
                    <LineChart />
                </div>
            </div>
        </div>
    );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(Reports);